<template>
  <div id="preview" class="sheet">
    <div class="mainSheet">
      <div class="header">
        <div class="printTitle">{{STORENAME}}</div>
        <div class="printName">銷貨憑單</div>
        <div class="rightTop">電話:{{TEL}} <span v-if="FAX">傳真:{{FAX}}</span><br>{{ADDRESS}}</div>
        <div class="leftTop">銷貨日期 : {{moment(sheet.visitDate).format('YYYY/MM/DD')}}<br>訂單編號 : A{{sheet.serialNo?.toString().padStart(5, '0')}}</div>
      </div>
      <div class="rightBottom">
        業務經辦: {{getname(sheet.salesman?.name)}}<br>列印時間: {{moment().format('YYYY/MM/DD HH:mm')}}
      </div>
      <table class="companyInfo">
        <tbody>
          <tr>
            <td>
              <div><div class="span">客戶名稱</div> {{(sheet.recipient || sheet.orderer)}}</div>
            </td>
            <td>
              <div><div class="span">取貨方式</div> <span class="typeHighlight">{{sheet.type}}</span> <span v-if="sheet.type==='自取'" class="space Bigger typeHighlight">{{moment(sheet.visitDate).format('yyyy/MM/DD')}} {{sheet.visitTime}}</span> </div>
            </td>
          </tr>
          <tr>
            <td>
              <div><div class="span">聯絡電話</div> {{sheet.recipientTel || sheet.ordererTel}}</div>
            </td>
            <td>
              <div><div class="span">統一編號</div> {{sheet.agencyID}}</div>
            </td>
          </tr>
          <tr>
            <td>
              <div><div class="span">送貨地址</div> {{sheet.address}}</div>
            </td>
            <td>
              <div><div class="span">公司行號</div> {{sheet.agencyName}}</div>
            </td>
          </tr>
        </tbody>
      </table>
      <table class="products">
        <thead>
          <tr>
            <th>NO.</th>
            <th>品名</th>
            <th>數量</th>
            <th>單位</th>
            <th>單價</th>
            <th>小計</th>
            <th>備註</th>
          </tr>
        </thead>
        <tbody class="productslist">
          <template  v-for="({ name, finalPrice, unit, count, items, t }, c) in Orders">
            <template v-if="items.length===0">
              <tr :key="`prod-${c}`" >
                <td>{{c+1}}</td>
                <td>{{name}}</td>
                <td>{{count}}</td>
                <td>{{unit}}</td>
                <td>{{finalPrice}}</td>
                <td>{{finalPrice * count}}</td>
                <td></td>
              </tr>
            </template>
            <template v-else>
              <template v-for="({name:subname, count: subcount},i) in items">
                <tr :key="`prod-${c}-${i}`" v-if="i===0">
                  <td>{{c+1}}</td>
                  <td>{{name}}</td>
                  <td>{{count}}</td>
                  <td>{{unit}}</td>
                  <td>{{finalPrice}}</td>
                  <td>{{finalPrice * count}}</td>
                  <td>
                    <div v-if="t==='set'">
                      <span>{{subname}}</span>
                      <span :style="{marginLeft:'auto'}">x{{subcount}}</span>
                    </div>
                  </td>
                </tr>
                <tr :key="`prod-${c}-${i}`" v-else>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td v-if="t==='set'">
                    <div>
                      <span>{{subname}}</span>
                      <span :style="{marginLeft:'auto'}">x{{subcount}}</span>
                    </div>
                  </td>
                </tr>
              </template>
            </template>
          </template>
          <tr :style="{minHeight:0}">
            <td :style="{height: '100%'}"></td><td></td><td></td><td></td><td></td><td></td><td></td>
          </tr>
        </tbody>
        <tbody :style="{height: '20mm'}"><tr :style="{borderTop:'1px solid'}">
          <td colspan="2" :style="{height: '20mm', borderRight: '1px solid', padding: '2px 8px'}">
            <div class="remark" v-html="'備註: ' + (sheet.remarkClient||'')"></div>
          </td>
          <td colspan="3" :style="{height: '20mm', borderRight: '1px solid', padding: '2px 8px'}">
            <div class="sign">客戶簽收</div>
          </td>
          <td colspan="2" :style="{height: '20mm', padding: '2px 8px'}">
            <div class="totalprice">
              <div>
                <div><div>合計</div><div>$ {{sheet.price - Math.floor(sheet.price * 5 / 105)}}</div></div>
                <div><div>營業稅</div><div>$ {{Math.floor(sheet.price * 5 / 105)}}</div></div>
                <div><div>總金額</div><div>$ {{sheet.price}}</div></div>
              </div>
              <div>
                <div><div>已付訂金</div><div>$ {{(sheet.remit?.price || sheet.remitInfo?.Trans_Amount) || 0}}</div></div>
                <div><div>應附尾款</div><div>$ {{sheet.price - (sheet.remit?.price || sheet.remitInfo?.Trans_Amount || 0)}}</div></div>
              </div>
            </div>
          </td>
        </tr></tbody>
        <tfoot>
          <tr></tr>
        </tfoot>
      </table>
      <div class="footer">
        <div>送貨人員:</div>
        <div>對單:</div>
        <div>對貨:</div>
        <div>撿貨:</div>
        <div/>
      </div>
    </div>
    <hr v-if="sheet.remark||sheet.remarkKitchen">
    <div class="remarkout" v-if="sheet.remark">
      <h2>備註:</h2>
      <p v-html="(sheet.remark || '').replaceAll('\n', '<br>')"></p>
    </div>
    <div class="remarkout Kitchen" v-if="sheet.remarkKitchen">
      <h2>內部備註</h2>
      <p v-html="(sheet.remarkKitchen || '').replaceAll('\n', '<br>')"></p>
    </div>
  </div>
</template>

<script>
const STORENAME = process.env.VUE_APP_HOME_NAME
const ADDRESS = process.env.VUE_APP_STORE_ADDRESS
const TEL = process.env.VUE_APP_STORE_TEL
const TAXID = process.env.VUE_APP_STORE_TAXID
const FAX = process.env.VUE_APP_STORE_FAX
export default {
  props: ['sheet', 'prodcates'],
  data () {
    return {
      ...{ STORENAME, ADDRESS, TEL, TAXID, FAX }
    }
  },
  computed: {
    Orders () {
      return this.getCollOrders(this.sheet.Orders || []).map(({ name, finalPrice, price, unit, count, items, t }) => {
        return {
          ...{ name, t, finalPrice: finalPrice || price, unit, count, items }
          // remark: (
          //   t === 'single'
          //     ? [...(items[0].opt), [].concat(...items[0].add.map(a => `${a.name}_${a.price && '+'}${a.price}`))].filter(a => a).join('<br>')
          //     : (items.map(e => [
          //       `${e.name}_${e.priceDiff && '+'}${e.priceDiff || ''}`,
          //       e.opt.join('|'),
          //       [].concat(...e.add.map(a => `${a.name} ${a.price}`))
          //     ].filter(e => e).join('<br>'))).filter(e => e).join('<br>')
          // )
        }
      })
    }
  },
  methods: {
    getHexPhone (tel) {
      const telHex = false
      if (!telHex) {
        return tel
      }
      const len = tel.length
      return tel.slice(0, len - 6) + '***' + tel.slice(-3)
    },
    getname (name) {
      const starInName = true
      if (!starInName) {
        return name
      }
      if (name) {
        const len = name.length
        switch (len) {
          case 2:
            return name[0] + '*'
          case 3:
            return name[0] + '*' + name[2]
          default:
            return name.slice(0, len - 2) + '*' + name.slice(-1)
        }
      } else {
        return ''
      }
    }
  }

}
</script>
<style>
:root {
  --fonts11: calc(11mm * 0.3);
  --fonts14: calc(14mm * 0.3);
  --fonts16: calc(16mm * 0.3);
  --fonts18: calc(18mm * 0.3);
}
</style>
<style scoped>
hr {
  border-top: 1px dashed #000000;
  margin-block: 2em 1em;
}
.remarkout {
  padding: 1em;
  border: 1px solid #000000;
  text-align: start;
  margin-bottom: 1em;
}
.mainSheet {
  position: relative;
}
.remarkDetail {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  margin-bottom: auto;
}
.remarkDetail>div{
  height: 2em;
}
.remark {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 2px;
  text-align: start;
}
.sign {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 2px;
  text-align: center;
}
.footer {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  padding: 0;
  font-size: var(--fonts11);
  height: 4em;
}
.footer>div{
  text-align: start;
  display: flex;
  align-items: flex-start;
  white-space: nowrap;
}
.footer span {
  display: inline-flex;
  height: 12mm;
  border-bottom: 1px solid;
  width: fill;
}
.totalprice {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  padding-inline: 5px;
}
.totalprice>div {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-end;
}
.totalprice>div>div {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
table.products {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #000000;
  line-height: 180%;
  font-size: var(--fonts11);
  height: 82mm;
  border-top: none;
}
table.products thead>tr {
  border-bottom: 1px solid;
}
table.products tfoot>tr {
  border-top: 1px solid;
  height: 0;
}
.productslist tr {
  height: 6mm;
  max-height: 6mm;
}
.productslist td {
  vertical-align: unset;
}
.productslist td {
  text-align: start;
  padding: 2px 8px;
  max-height: 10mm;
}
.productslist td >div {
  display: flex;
}
table.products th {
  line-height: 150%;
  padding-inline: 8px;
}
table.products th:nth-child(2) { width: inherit; text-align: start; }
table.products th:nth-child(4) { width: 3em; text-align: center; padding: 0; }
table.products th:nth-child(5) { width: 5em; text-align: end; }
table.products th:nth-child(6) { width: 5em; text-align: end; }
table.products th:nth-child(7) { width: 18em; text-align: start; }
.productslist td:nth-child(1) { width: 3em; text-align: center; }
.productslist td:nth-child(2) { width: inherit; text-align: start; }
.productslist td:nth-child(3) { width: 4em; text-align: center; }
.productslist td:nth-child(4) { width: 3em; text-align: center; }
.productslist td:nth-child(5) { width: 5em; text-align: end; }
.productslist td:nth-child(6) { width: 5em; text-align: end; }
table.products tr>:not(:first-child) {
  border-left: 1px solid #000000;
}
table.companyInfo {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #000000;
  line-height: 180%;
  font-size: var(--fonts11);
  margin-top: 5px;
  height: 16mm;
}
table.companyInfo td>div {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  color: #787878;
  max-height: var(--font18);
}
table.companyInfo>tr,
table.companyInfo td {
  height: var(--fonts18);
  width: 50%;
}
table.companyInfo>tr:last-child {
  border-bottom: 1px solid #000000;
}
table.companyInfo td>div>div.span {
  min-width: 4em;
  width: 4em;
  margin-right: 1em;
  text-align: justify;
  text-align-last: justify!important;
  color: #000000;
}
table.companyInfo td {
  text-align: start;
  padding: 2px 8px;
}
.sheet {
  position:relative;
}
.rightBottom {
  position: absolute;
  font-size: var(--fonts11);
  text-align: start;
  bottom: 0;
  right: 0;
}
.rightTop {
  position: absolute;
  font-size: var(--fonts11);
  text-align: start;
  bottom: 0;
  right: 0;
}
.leftTop {
  position: absolute;
  font-size: var(--fonts11);
  text-align: start;
  bottom: 0;
  left: 0;
}
.printName {
  margin-top: 10px;
  border-bottom: 1px solid #6D6D6D;
  width: fit-content;
  margin-inline: auto;
  text-align: center;
  font-size: var(--fonts16);
  line-height: 1em;
}
.printTitle {
  text-align: center;
  font-size: var(--fonts18);
  letter-spacing: .03em;
  line-height: 1em;
}
.header {
  /* border: 1px solid #CACACA; */
  position: relative;
  margin-bottom: 11px;
}
span.typeHighlight {
  font-weight: 700;
}
</style>
<style scoped>
#preview {
  position: fixed;
  top: 0;
  /* left: 100px; */
  left: 100vw;
  width: 210mm;
  height: fit-content;
  background-color: #FFFFFF;
  z-index: 100;
  overflow-y: auto;
  /* padding: 10mm; */
}
</style>
